<article class="lum-page lum-page__card lum-c-rfq-details">
  <header class="lum-page-header lum-page-header--sticky">
    <div class="lum-page-header__heading-group align-items-baseline">
      <h2 class="lum-page-header__heading mr-1">
        <a [routerLink]="['/inventory/skus']">SKUs</a> /
        <ng-container *ngIf="rfq && rfq.id">
          <span *ngIf="rfq.internal_sku">[{{ rfq.internal_sku }}]</span>
          {{ rfq.product_name }}
        </ng-container>
      </h2>
      <ng-container *ngIf="rfq && rfq.id">
        <small
          class="text-info font-weight-bold"
          [ngClass]="rfq.is_discontinued == 1 ? 'text-warning' : 'text-success'"
          >{{ rfq.is_discontinued == 1 ? 'DISCONTINUED' : 'ACTIVE' }}</small
        >
      </ng-container>
    </div>
    <div
      *ngIf="rfq && rfq.product_type_id != 3"
      class="lum-page-header__data lum-c-rfq-details__data"
    >
      <div class="lum-c-rfq-details__data-item">
        <span class="text-black text-center">
          <h6 class="m-0 p-0">QTY OnHand</h6>
          <p
            class="m-0 p-0"
            *ngIf="rfq.stock && rfq.stock.qty_onhand; else qty_onhand_zero"
          >
            {{ rfq.stock.qty_onhand | decimalPlaces }}
            <ng-container *ngIf="!hideUom">
              {{ rfq?.base_unit_of_measure?.name }}
            </ng-container>
            <ng-container
              *ngIf="
                !hideUom &&
                rfq.conversion_factor &&
                (rfq?.default_selling_unit?.name !==
                  rfq?.base_unit_of_measure?.name ||
                  (rfq.stock.qty_onhand | decimalPlaces) !==
                    (rfq.stock.qty_onhand / rfq.conversion_factor | decimalPlaces))
              "
            >
              /
              {{ rfq.stock.qty_onhand / rfq.conversion_factor | decimalPlaces }}
              {{ rfq?.default_selling_unit?.name }}
            </ng-container>
          </p>
          <ng-template #qty_onhand_zero>
            <p class="m-0 p-0">
              0
              <ng-container *ngIf="!hideUom">
                {{ rfq?.base_unit_of_measure?.name }}
              </ng-container>
              <ng-container
                *ngIf="
                  !hideUom &&
                  rfq.conversion_factor &&
                  rfq?.default_selling_unit?.name !==
                    rfq?.base_unit_of_measure?.name
                "
              >
                / 0 {{ rfq?.default_selling_unit?.name }}
              </ng-container>
            </p>
          </ng-template>
        </span>
      </div>
      <div class="lum-c-rfq-details__data-item">
        <span class="text-black text-center">
          <h6 class="m-0 p-0">QTY Incoming</h6>
          <p class="m-0 p-0" *ngIf="rfq.stock && rfq.stock.qty_incoming">
            {{ rfq.stock.qty_incoming | decimalPlaces }}
            <ng-container *ngIf="!hideUom">
              {{ rfq?.base_unit_of_measure?.name }}
            </ng-container>
            <ng-container
              *ngIf="
                !hideUom &&
                rfq.conversion_factor &&
                (rfq?.default_selling_unit?.name !==
                  rfq?.base_unit_of_measure?.name ||
                  (rfq.stock.qty_incoming | decimalPlaces) !==
                    (rfq.stock.qty_incoming / rfq.conversion_factor
                      | decimalPlaces))
              "
            >
              /
              {{ rfq.stock.qty_incoming / rfq.conversion_factor | decimalPlaces }}
              {{ rfq?.default_selling_unit?.name }}
            </ng-container>
          </p>
          <p class="m-0 p-0" *ngIf="!rfq.stock || !rfq.stock.qty_incoming">
            0
            <ng-container *ngIf="!hideUom">
              {{ rfq?.base_unit_of_measure?.name }}
            </ng-container>
            <ng-container
              *ngIf="
                !hideUom &&
                rfq.conversion_factor &&
                rfq?.default_selling_unit?.name !== rfq?.base_unit_of_measure?.name
              "
            >
              / 0 {{ rfq?.default_selling_unit?.name }}
            </ng-container>
          </p>
        </span>
      </div>
      <div class="lum-c-rfq-details__data-item">
        <span class="text-black text-center">
          <h6 class="m-0 p-0">QTY Available</h6>
          <p class="m-0 p-0" *ngIf="rfq.stock; else qty_available_zero">
            {{ rfq.stock.qty_onhand - rfq.stock.qty_pending | decimalPlaces }}
            <ng-container *ngIf="!hideUom">
              {{ rfq?.base_unit_of_measure?.name }}
            </ng-container>
            <ng-container
              *ngIf="
                !hideUom &&
                rfq.conversion_factor &&
                (rfq?.default_selling_unit?.name !==
                  rfq?.base_unit_of_measure?.name ||
                  (rfq.stock.qty_onhand - rfq.stock.qty_pending | decimalPlaces) !==
                    ((rfq.stock.qty_onhand - rfq.stock.qty_pending) /
                      rfq.conversion_factor | decimalPlaces))
              "
            >
              /
              {{
                (rfq.stock.qty_onhand - rfq.stock.qty_pending) /
                  rfq.conversion_factor | decimalPlaces
              }}
              {{ rfq?.default_selling_unit?.name }}
            </ng-container>
          </p>
          <ng-template #qty_available_zero>
            <p class="m-0 p-0">
              0
              <ng-container *ngIf="!hideUom">
                {{ rfq?.base_unit_of_measure?.name }}
              </ng-container>
              <ng-container
                *ngIf="
                  !hideUom &&
                  rfq.conversion_factor &&
                  rfq?.default_selling_unit?.name !==
                    rfq?.base_unit_of_measure?.name
                "
              >
                / 0 {{ rfq?.default_selling_unit?.name }}
              </ng-container>
            </p>
          </ng-template>
        </span>
      </div>
      <div class="lum-c-rfq-details__data-item">
        <span class="text-black text-center">
          <h6 class="m-0 p-0">QTY Pending</h6>
          <ng-container
            [ngTemplateOutlet]="pendingListLink"
            [ngTemplateOutletContext]="{ item: rfq }"
          ></ng-container>
        </span>
      </div>
      <div class="lum-c-rfq-details__data-item">
        <span class="text-black text-center">
          <h6 class="m-0 p-0">Last Month Sale Qty</h6>
          <p class="m-0 p-0" *ngIf="rfq.last_month_sale; else last_month_sale_zero">
            {{ rfq?.last_month_sale.quantity | decimalPlaces }}
          </p>
          <ng-template #last_month_sale_zero>
            <p class="m-0 p-0">0</p>
          </ng-template>
        </span>
      </div>
      <div class="lum-c-rfq-details__data-item">
        <span class="text-black text-center">
          <h6 class="m-0 p-0">Last Month Sale Qty</h6>
          <p
            class="m-0 p-0"
            *ngIf="rfq.month_to_date_sale; else month_to_date_sale_zero"
          >
            {{ rfq?.month_to_date_sale.quantity | decimalPlaces }}
          </p>
          <ng-template #month_to_date_sale_zero>
            <p class="m-0 p-0">0</p>
          </ng-template>
        </span>
      </div>
    </div>
    <div *ngIf="rfq && rfq.id" class="lum-page-header__actions">
      <div ngbDropdown class="d-inline-block">
        <button
          ngbDropdownToggle
          mat-mini-fab
          type="button"
          color="default"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="flaticon-more-1"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="action-button">
          <button
            type="button"
            ngbDropdownItem
            *ngIf="checkIfCanCreateAdjustmentEntry()"
            (click)="createAdjustmentEntry(rfq)"
          >
            <i class="fas fa-edit"></i> Create Adjustment Entry
          </button>
          <button
            type="button"
            ngbDropdownItem
            (click)="editRfq(rfq)"
            *ngIf="authService.loginUser.prwx == 7"
          >
            <i class="fas fa-edit"></i> Edit SKU
          </button>
          <!-- <button
            type="button"
            ngbDropdownItem
            (click)="transferRfq()"
            title="Transfer SKU"
          >
            <i class="fas fa-map-pin"></i> Transfer SKU
          </button> -->
          <button
            type="button"
            ngbDropdownItem
            (click)="exportRfqToPDF(rfq)"
            title="Export SKU"
          >
            <i class="fas fa-file-pdf"></i> Export to PDF
          </button>
          <button
            type="button"
            ngbDropdownItem
            (click)="promoteVariantToMasterSku(rfq)"
            *ngIf="rfq.variant_parent_id !== 0"
          >
            <i class="fas fa-file-pdf"></i> Promote Variant SKU to Master SKU
          </button>
          <button
            type="button"
            ngbDropdownItem
            (click)="assignRFQ()"
            title="Assign SKU"
            *ngIf="authService.loginUser.role > 2"
          >
            <i class="fas fa-user-friends"></i> Assign SKU
          </button>
          <a [href]="link" [download]="qrCodeFileName"
            ><button
              type="button"
              ngbDropdownItem
              (click)="dlQrCode()"
              title="Export QR Code"
            >
              <i class="fas fa-qrcode"></i> Export QR Code
            </button></a
          >
          <button
            ngbDropdownItem
            (click)="discontinue(rfq)"
            *ngIf="
              rfq.is_discontinued == 0 &&
              authService.loginUser.is_admin &&
              authService.loginUser.prwx == 7
            "
            class="text-warning"
          >
            <i class="fas fa-stop text-warning"></i>
            Discontinue SKU
          </button>
          <button
            ngbDropdownItem
            (click)="continue(rfq)"
            *ngIf="
              rfq.is_discontinued == 1 &&
              authService.loginUser.is_admin &&
              authService.loginUser.prwx == 7
            "
            class="text-primary"
          >
            <i class="fas fa-play text-primary"></i>
            Reactivate SKU
          </button>
        </div>
      </div>
      <!-- <button type="button" class="ml-2 btn btn-default text-info text-center"
                (click)="rfqService.getPdf(rfq.id);" title="Export SKU">
                <i class="fas fa-file-pdf"></i>
            </button> -->

      <!-- <button type="button" class="ml-2 btn btn-default text-primary text-center" (click)="viewClientInfo()"
                title="View client details">
                <i class="fas fa-user-tie"></i>
            </button> -->
    </div>
  </header>

  <div class="lum-page-content">
    <div class="d-none">
      <qrcode
        #qrcode
        [qrdata]="qrCodeData"
        [width]="256"
        [errorCorrectionLevel]="'M'"
        elementType="img"
        allowEmptyString="true"
      ></qrcode>
    </div>

    <div *ngIf="!rfq" align="center" class="text-center">
      <br />
      <h6 [translate]="'GENERAL.GETTING_RECORDS'" class="text-center">
        <i class="fas fa-spinner fa-spin"></i> Getting records...
      </h6>
      <br />
    </div>

    <mat-tab-group
      #tabGroup
      *ngIf="rfq && rfq.id"
      dynamicHeight="true"
      [(selectedIndex)]="selectedIndex"
      (selectedTabChange)="onTabChange($event)"
    >
      <ng-container *ngFor="let tab of filteredTabs; trackBy: trackById">
        <mat-tab [id]="tab.id" [label]="tab.label">
          <ng-template mat-tab-label>
            <i [class]="tab.icon + ' mr-1'"></i> {{ tab.label | translate }}
          </ng-template>

          <!-- Details tab -->
          <cnc-rfq-details-page
            *ngIf="tab.id === 'details' && childComponentVisible"
            [rfq]="rfq"
            (syncBomRfqsEvent)="onSyncBomRfqs($event)"
          ></cnc-rfq-details-page>

          <!-- Product Substitutions tab -->
          <lum-rfq-product-substitution
            *ngIf="tab.id === 'substitutions'"
            [productType]="rfq.type"
            [productId]="rfq.id"
          ></lum-rfq-product-substitution>

          <!-- Kit Items tab -->
          <cnc-rfq-details-kit-items
            *ngIf="tab.id === 'kit-items'"
            [kitItems]="rfq?.kit_items || []"
          ></cnc-rfq-details-kit-items>

          <!-- Product Variants tab -->
          <cnc-rfq-variant-skus
            *ngIf="tab.id === 'variants' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-variant-skus>

          <!-- Attachments tab -->
          <cnc-rfq-attachments
            *ngIf="tab.id === 'attachments' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-attachments>

          <!-- Pricing tab -->
          <cnc-rfq-pricing
            *ngIf="tab.id === 'pricing' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-pricing>

          <!-- Quotations tab -->
          <cnc-rfq-details-quotations
            *ngIf="tab.id === 'quotations' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-details-quotations>

          <!-- Messages tab -->
          <cnc-comments
            *ngIf="tab.id === 'messages'"
            [commentType]="commentType"
          ></cnc-comments>

          <!-- Sales tab -->
          <cnc-rfq-details-sales
            *ngIf="tab.id === 'sales' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-details-sales>

          <!-- Costs tab -->
          <ng-container *ngIf="tab.id === 'costs'">
            <ng-container *ngxPermissionsOnly="'skuUnitCost.read'">
              <cnc-rfq-details-cost
                *ngIf="childComponentVisible"
                [rfq]="rfq"
              ></cnc-rfq-details-cost>
            </ng-container>
          </ng-container>

          <!-- Unit Conversions tab -->
          <cnc-rfq-unit-of-conversions
            *ngIf="tab.id === 'unit-conversions' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-unit-of-conversions>

          <!-- COGS/Margin tab -->
          <cnc-rfq-details-cogs
            *ngIf="tab.id === 'cogs-margin' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-details-cogs>

          <!-- Qty Logs tab -->
          <cnc-rfq-details-qty-logs
            *ngIf="tab.id === 'qty-logs' && childComponentVisible"
            [rfq]="rfq"
          ></cnc-rfq-details-qty-logs>

          <!-- Supplier SKUs tab -->
          <lum-supplier-sku
            *ngIf="tab.id === 'supplier-skus'"
            [rfq]="rfq"
          ></lum-supplier-sku>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>
</article>

<ng-template #pendingListLink let-rfq="item">
  <div class="text-center">
    <a
      *ngIf="
        rfq.type !== productTypes.KIT && rfq.pendingQuantity > 0;
        else noPending
      "
      href="javascript:;"
      (click)="viewPendingRfqStockDetails(rfq)"
      title="View pending stock transactions"
    >
      {{ rfq.pendingQuantity | decimalPlaces }}
      <ng-container *ngIf="!hideUom">
        {{ rfq?.base_unit_of_measure?.name }}
      </ng-container>
      <ng-container
        *ngIf="
          !hideUom &&
          rfq.conversion_factor &&
          (rfq?.default_selling_unit?.name !== rfq?.base_unit_of_measure?.name ||
            (rfq.pendingQuantity | decimalPlaces) !==
              (rfq.pendingQuantity / rfq.conversion_factor | decimalPlaces))
        "
      >
        / {{ rfq.pendingQuantity / rfq.conversion_factor | decimalPlaces }}
        {{ rfq?.default_selling_unit?.name }}
      </ng-container>
    </a>
    <span> </span>
  </div>
  <ng-template #noPending>
    {{ rfq.pendingQuantity | decimalPlaces }}
    <ng-container *ngIf="!hideUom">
      {{ rfq?.base_unit_of_measure?.name }}
    </ng-container>
    <ng-container
      *ngIf="
        !hideUom &&
        rfq.conversion_factor &&
        (rfq?.default_selling_unit?.name !== rfq?.base_unit_of_measure?.name ||
          (rfq.pendingQuantity | decimalPlaces) !==
            (rfq.pendingQuantity / rfq.conversion_factor | decimalPlaces))
      "
    >
      / {{ rfq.pendingQuantity / rfq.conversion_factor | decimalPlaces }}
      {{ rfq?.default_selling_unit?.name }}
    </ng-container>
  </ng-template>
</ng-template>
